export default __webpack_public_path__ + "static/media/Karla-Bold.f0553c32.ttf";